export default __webpack_public_path__ + "static/media/icon-coin-axl.1a00e7a0.svg";